import * as React from "react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import { SelectPopoverProps } from "./SelectPopoverProps";
import SelectListItem from "./SelectListItem";

function SelectPopover({
  render,
  options = [],
  anchorOrigin = {
    vertical: "bottom",
    horizontal: "left",
  },
  onChange = () => {},
}: SelectPopoverProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      {render(handleClick)}
      {options.length > 0 && (
        <Popover sx={{ mt: 2 }} open={open} anchorEl={anchorEl} onClose={handleClose} anchorOrigin={anchorOrigin}>
          <Box>
            <ul
              style={{
                margin: 0,
                padding: 0,
                listStyle: "none",
                minWidth: "9.375rem",
                maxWidth: "18.75rem",
                maxHeight: "21.875rem",
              }}
            >
              {options.map((item, index) => (
                <SelectListItem
                  key={item.value || index}
                  onClick={() => {
                    handleClose();
                    onChange(index, item.value);
                  }}
                >
                  <Typography color={`${item.color ?? "secondary"}.main`}>{item.text}</Typography>
                </SelectListItem>
              ))}
            </ul>
          </Box>
        </Popover>
      )}
    </>
  );
}
export default SelectPopover;
